<form #clientform="ngForm" class="form-v2 form-horizontal">
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="client.FirstName || client.LastName; else newContactPerson">Edit Individual</h4>
        <ng-template #newContactPerson>
            <h4 class="modal-title">New Individual</h4>
        </ng-template>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="col-sm-3 control-label text-info"> <span class="mandatory-field"></span> First Name </label>
            <div class="col-sm-9">
                <input
                    legacy-css
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    class="form-control"
                    [(ngModel)]="client.FirstName"
                    required
                    autofocus
                    maxlength="50" />
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-3 control-label text-info"> <span class="mandatory-field"></span>Last Name </label>
            <div class="col-sm-9">
                <input
                    legacy-css
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    class="form-control"
                    [(ngModel)]="client.LastName"
                    required
                    maxlength="50" />
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-3 control-label text-info"> <span class="mandatory-field"></span>Email </label>
            <div class="col-sm-9">
                <input
                    legacy-css
                    name="email"
                    type="email"
                    email
                    placeholder="Email"
                    class="form-control"
                    [(ngModel)]="client.Email"
                    [ngModelOptions]="{}"
                    required
                    maxlength="50" />
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-3 control-label text-info" translate="general.address.mobile"></label>
            <div class="col-sm-9">
                <phone-number
                    name="phoneMobile"
                    [number]="client.Mobile"
                    [(ngModel)]="client.Mobile"
                    (parsednumber)="client.Mobile = $event"></phone-number>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-bx-secondary-stroked" type="button" (click)="cancel()">Cancel</button>
        <button type="button" class="btn-bx-primary ml-2" (click)="ok()" [disabled]="!clientform.valid">Save &amp; Close</button>
    </div>
</form>
